var LOCAL_API_URL: string | undefined = "",
  LOCAL_LOGO_URL: string | undefined = "",
  LOCAL_CLIENT_NAME: string | undefined = "",
  LOCAL_RE_CAPTCHA_V2_KEY: string | undefined = "",
  LOCAL_IS_CAPTCHA: string | undefined = "",
  LOCAL_LOGO_WIDTH: string | undefined = "",
  LOCAL_SOUND_ON: string | undefined = "";

const readJsonSync = async () => {
  LOCAL_API_URL = process.env.API_URL;
  LOCAL_LOGO_URL = process.env.API_URL + "/logo.png";
  LOCAL_CLIENT_NAME = process.env.APP_CLIENT_NAME;
  LOCAL_IS_CAPTCHA = process.env.IS_CAPTCHA;
  LOCAL_RE_CAPTCHA_V2_KEY = process.env.RE_CAPTCHA_V2_KEY;
  LOCAL_LOGO_WIDTH = process.env.APP_LOGO_WIDTH;
  LOCAL_SOUND_ON = process.env.APP_LOGO_WIDTH;
};

export const CLIENT_NAME = async () => {
  if (LOCAL_CLIENT_NAME === undefined || LOCAL_CLIENT_NAME === "") {
    await readJsonSync();
  }

  return LOCAL_CLIENT_NAME;
};

export const LOGO_URL = async () => {
  if (LOCAL_LOGO_URL === undefined || LOCAL_LOGO_URL === "") {
    LOCAL_LOGO_URL = process.env.apiURL + "/logo.png";
  }

  return LOCAL_LOGO_URL;
};
export const LOGO_WIDTH = async () => {
  if (LOCAL_LOGO_WIDTH === undefined || LOCAL_LOGO_WIDTH === "") {
    await readJsonSync();
  }

  return LOCAL_LOGO_WIDTH;
};
export const RE_CAPTCHA_V2_KEY = async () => {
  if (LOCAL_RE_CAPTCHA_V2_KEY === undefined || LOCAL_RE_CAPTCHA_V2_KEY === "") {
    LOCAL_RE_CAPTCHA_V2_KEY = process.env.RE_CAPTCHA_V2_KEY;
  }

  return LOCAL_RE_CAPTCHA_V2_KEY;
};
export const IS_CAPTCHA = async () => {
  if (LOCAL_IS_CAPTCHA === undefined || LOCAL_IS_CAPTCHA === "") {
    LOCAL_IS_CAPTCHA = process.env.IS_CAPTCHA;
  }
  if (LOCAL_IS_CAPTCHA === undefined || LOCAL_IS_CAPTCHA === "") {
    LOCAL_IS_CAPTCHA = "YES";
  }

  return LOCAL_IS_CAPTCHA;
};

export const API_URL = async () => {
  if (LOCAL_API_URL === undefined || LOCAL_API_URL === "") {
    await readJsonSync();
  }

  return LOCAL_API_URL;
};

export const PRIMARY_COLOR = () => {
  //return window.localStorage.getItem('PrimaryColor') || '#7467ef';
  return "#1976D2";
};
export const SECONDARY_COLOR = () => {
  //return window.localStorage.getItem('SecondaryColor') || '#7467ef';
  return "#1976D2";
};
export const PRIMARY_HOVER_COLOR = () => {
  //return window.localStorage.getItem('PrimaryHoverColor') || '#7467ef';
  return "#7467ef";
};

export const SECONDARY_HOVER_COLOR = () => {
  //return window.localStorage.getItem('SecondaryHoverColor') || '#7467ef';
  return "#7467ef";
};

export const APP_BAR_COLOR = () => {
  //return window.localStorage.getItem('AppBarColor') || '#7467ef';
  return "#7467ef";
};
export const MENU_FORE_COLOR = () => {
  // return window.localStorage.getItem('ForeColor') || '#ffffff';
  return "#ffffff";
};

export const NAV_BAR_COLOR = () => {
  //eturn window.localStorage.getItem('NavBarColor') || '#c4c4c4';
  return "#c4c4c4";
};

export const RESET_COLOR = () => {
  //return localStorage.getItem('ResetColor') || '#fff';
  return "#fff";
};

export const SOUND_ON = async () => {
  if (LOCAL_SOUND_ON === undefined || LOCAL_SOUND_ON === "") {
    await readJsonSync();
  }

  return LOCAL_SOUND_ON;
};
